export const defaultRoute = "/home";
